



import { useContext } from "react"
import { GlobalContext } from "../GlobalContext"
import Modal from "./Modal"
import Button from "../formfields/Button"
import Spinner from "./Spinner"

type Props = {
}


function LoginModal({
}: Props) {

    const {
        connectionState
    } = useContext(GlobalContext)



    return <Modal>
        <div className={`w-full flex flex-col gap-4 items-center`}>
            <Spinner size="large" alignment="left">Logging in...</Spinner>
        </div>
    </Modal>
}

export default LoginModal